import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/screen.css';

function VIPPreview() {
  const navigate = useNavigate();

  // Sample VIP clients data
  const sampleVIPClients = [
    {
      po_number: 'PO-2024-001',
      client: 'BEER GARDEN BELLAVISTA SPA',
      address: 'Av. Bellavista 123, Providencia',
      po_date: '2024-01-15T10:30:00Z',
      packing: true,
      carts: [
        { code: 'CART-01', status: 'in_use' },
        { code: 'BASKET-02', status: 'in_use' }
      ]
    },
    {
      po_number: 'PO-2024-002',
      client: 'BEMA S.A.',
      address: 'Las Condes 456, Santiago',
      po_date: '2024-01-15T11:00:00Z',
      packing: false,
      carts: [
        { code: 'CART-03', status: 'in_use' }
      ]
    },
    {
      po_number: 'PO-2024-003',
      client: 'RESTAURANTES BOLOGNA LTDA',
      address: 'Vitacura 789, Las Condes',
      po_date: '2024-01-15T11:30:00Z',
      packing: true,
      carts: [
        { code: 'BASKET-01', status: 'in_use' }
      ]
    }
  ];

  // Sample regular clients data
  const sampleRegularClients = [
    {
      po_number: 'PO-2024-004',
      client: 'Regular Restaurant SPA',
      address: 'Ñuñoa 321, Santiago',
      po_date: '2024-01-15T09:00:00Z',
      packing: false,
      carts: [
        { code: 'CART-04', status: 'in_use' }
      ]
    },
    {
      po_number: 'PO-2024-005',
      client: 'Local Cafe LTDA',
      address: 'Providencia 654, Santiago',
      po_date: '2024-01-15T08:30:00Z',
      packing: true,
      carts: [
        { code: 'BASKET-03', status: 'in_use' }
      ]
    }
  ];

  // Helper function to format cart type
  const formatCartType = (code) => {
    if (code.startsWith('CART-')) {
      const number = code.split('-')[1];
      return `Abarrote Nº ${number}`;
    }
    if (code.startsWith('BASKET-')) {
      const number = code.split('-')[1];
      return `Frío nº ${number}`;
    }
    return code;
  };

  // Calculate elapsed time
  const calculateElapsedTime = (poDate) => {
    const poDateObj = new Date(poDate);
    const now = new Date();
    const diffInMs = now - poDateObj;
    const hours = Math.floor(diffInMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));
    return `${hours}h ${minutes}m`;
  };


  const ClientCard = ({ po, isVIP = false }) => {
    const elapsedTime = calculateElapsedTime(po.po_date);
    const isVIPClient = isVIP;

    return (
      <div className={`client-details ${isVIPClient ? 'vip-client' : ''}`}>
        <div className="client-header">
          <div>
            <strong>{po.po_number}</strong> {po.client}
          </div>
          {isVIPClient && <span className="vip-badge">VIP</span>}
        </div>

        <div className="packing-info" style={{ display: 'flex', gap: '8px' }}>
          {po.packing && (
            <span className="packing-badge">
              📦 EMBALAR
            </span>
          )}
        </div>

        {po.address && <div className="client-address">{po.address}</div>}

        <div className="time-elapsed">
          <strong>Tiempo:</strong> {elapsedTime}
        </div>

        {po.carts && po.carts.length > 0 && (
          <ul>
            {po.carts.map((cart, cartIndex) => (
              <li key={cartIndex}>
                {formatCartType(cart.code)}
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  };

  return (
    <div className="screen-margin">
      <button className="adminproductos-back-button" onClick={() => navigate('/init')}>
        &#8592;
      </button>

      <h1 className="page-title">Vista Previa - Clientes VIP</h1>

      <div className="screen-container">
        <button className="screen-logout-button" onClick={() => navigate('/init')}>
          Volver
        </button>

        <div className="screen-column">
          <h2>
            Pendientes de pickeo (Con VIP)
            <div className="count-box">{sampleVIPClients.length + sampleRegularClients.length}</div>
          </h2>

          {/* VIP Clients First */}
          {sampleVIPClients.map((po, index) => (
            <ClientCard key={`vip-${index}`} po={po} isVIP={true} />
          ))}

          {/* Regular Clients */}
          {sampleRegularClients.map((po, index) => (
            <ClientCard key={`regular-${index}`} po={po} isVIP={false} />
          ))}
        </div>

        <div className="screen-column">
          <h2>
            Solo Clientes VIP
            <div className="count-box">{sampleVIPClients.length}</div>
          </h2>

          {sampleVIPClients.map((po, index) => (
            <ClientCard key={`vip-only-${index}`} po={po} isVIP={true} />
          ))}
        </div>

        <div className="screen-column">
          <h2>
            Clientes Regulares
            <div className="count-box">{sampleRegularClients.length}</div>
          </h2>

          {sampleRegularClients.map((po, index) => (
            <ClientCard key={`regular-only-${index}`} po={po} isVIP={false} />
          ))}
        </div>

        <div className="screen-column">
          <h2>
            Información VIP
            <div className="count-box">ℹ️</div>
          </h2>

          <div className="client-details">
            <div className="client-header">
              <strong>Características VIP:</strong>
            </div>
            <ul>
              <li>📋 Aparecen al inicio de la lista</li>
              <li>🟡 Borde dorado simple</li>
              <li>🏷️ Badge "VIP" discreto</li>
              <li>📱 Mismo hover que clientes regulares</li>
            </ul>
          </div>

          <div className="client-details">
            <div className="client-header">
              <strong>Clientes VIP Actuales:</strong>
            </div>
            <ul>
              <li>BEER GARDEN BELLAVISTA SPA</li>
              <li>BEMA S.A.</li>
              <li>RESTAURANTES BOLOGNA LTDA</li>
              <li>GMW FOOD S.P.A.</li>
              <li>SIETE TENEDORES SPA</li>
              <li>Y más...</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VIPPreview;
